"use client";
import { FeedPostAuthor } from "../FeedPostAuthor";
import { FeedPostDto } from "@/api/posts/types";
import React from "react";
import CallingAllArtist from "@/assets/graphics/backgrounds/calling-artist.svg";
import Link from "next/link";
import { getArtOrderRouteById } from "../../ArtOrder/helpers";

export interface Props {
  feedPost: FeedPostDto;
  forceLightTheme?: boolean;
}

function FeedPostArtOrderContent({ feedPost, forceLightTheme }: Props) {
  const artOrderHref = getArtOrderRouteById(feedPost.artOrder!.id);

  return (
    <div>
      <div className="flex flex-row justify-between mb-2 md:mb-1">
        <FeedPostAuthor feedPost={feedPost} forceLightTheme={forceLightTheme} />
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: feedPost.text!,
        }}
        className="text-body-3 leading-[22px] mb-2 md:mb-4 whitespace-pre-line mt-4"
      />
      <Link
        className="text-red text-body-2 font-bold endemic:text-primary"
        href={artOrderHref}
      >
        View Order
      </Link>

      <Link href={artOrderHref}>
        <CallingAllArtist className="w-full pb-4 pt-4" />
      </Link>
    </div>
  );
}

export default FeedPostArtOrderContent;
